import { IS_ENABLED_ECOMMERCE_OPTIONS, SITE_TYPE } from "../constants";

export const productsFilters = [
    {
        id: "keyword",
        name: "Palabra clave",
        description: "Filtra por una palabra claves",
        icon: "🗝",
        conflicts: ["barcode"],
        show: true
    },
    {
        id: "sku",
        name: "SKU",
        description: "Filtra por SKU",
        icon: "🛍",
        conflicts: [
            "line",
            "brand",
            "barcode",
            "active",
            "keyword",
            "stock",
            "priceOffer"
        ],
        show: true
    },
    {
        id: "barcode",
        name: "Código de barrras",
        description: "Filtra por código de barras",
        icon: "📡",
        conflicts: [
            "line",
            "brand",
            "sku",
            "active",
            "keyword",
            "stock",
            "priceOffer"
        ],
        show: true
    },
    {
        id: "stock",
        name: "Stock",
        description:
            "Filtra por rango de stock de las referencias del producto",
        icon: "📦",
        conflicts: ["barcode", "sku"],
        show: true
    },
    {
        id: "priceOffer",
        name: "Precio de venta",
        description: "Filtra por rango de precio de venta del producto",
        icon: "💰",
        conflicts: ["barcode", "sku"],
        show: true
    },
    {
        id: "active",
        name: "Publicado",
        description: "Filtra si esta publicado o oculto",
        icon: "🟡",
        conflicts: ["barcode"],
        show: IS_ENABLED_ECOMMERCE_OPTIONS
    },
    {
        id: "brand",
        name: "Marca",
        description: "Filtra entre las marcas registradas",
        scope: "",
        icon: "🔖",
        conflicts: ["barcode"],
        show: true,
        permissions: ["brand:List"]
    },
    {
        id: "line",
        name: "Subcategoría",
        description: "Filtra entre las subcategorías registradas",
        scope: "",
        icon: "➖",
        conflicts: ["barcode"],
        show: true,
        permissions: ["line:List"]
    }
];

export const ordersFilters = [
    {
        id: "deliveryStatus",
        name: "Estado",
        description:
            "Filtra entre los estados de la entrega, este filtro de ayudará a dar prioridades y ver el estado de tu operación.",
        icon: "🚚",
        conflicts: ["barcode", "id"],
        show: true
    },
    {
        id: "paymentStatus",
        name: "Estado de pago",
        description:
            "Filtra entre los estados de la pago, este filtro de ayudará a dar prioridades y ver el estado pago de las ordenes.",
        icon: "💳",
        conflicts: ["barcode", "id"],
        show: true
    },
    {
        id: "createdAt",
        name: "Fecha de creación",
        description:
            "Filtra las ordenes por el rango de fechas en que fueron creadas (solo fechas pasadas).",
        icon: "📅",
        conflicts: ["barcode", "id"],
        show: true
    },
    {
        id: "deliveryAt",
        name: "Fecha de entrega",
        description:
            "Filtra las ordenes por el rango de fechas de entrega programadas (fechas pasadas o futuras).",
        icon: "🚚",
        conflicts: ["barcode", "id"],
        show: true
    },
    {
        id: "customerId",
        name: "Cliente",
        description: "Filtra las ordenes por el cliente que realizó la compra.",
        icon: "🧑",
        conflicts: ["barcode", "id"],
        permissions: ["customer:List"],
        show: true
    },
    {
        id: "id",
        name: "ID",
        description: "Filtra por el id de la orden",
        icon: "#️⃣",
        conflicts: [
            "barcode",
            "dateRange",
            "timeAgo",
            "weekAgo",
            "monthAgo",
            "deliveryStatus",
            "paymentStatus",
            "sellerId",
            "type"
        ],
        show: true
    },
    {
        id: "uuid",
        name: "Código de barrras",
        description: "Filtra por código de barras de orden",
        icon: "📡",
        conflicts: [
            "id",
            "deliveryStatus",
            "paymentStatus",
            "sellerId",
            "type"
        ],
        show: true
    },
    {
        id: "type",
        name: "Tipo de orden",
        description: `Filtra por el tipo de orden, si es una orden por ${SITE_TYPE} o portal.`,
        icon: "🔱",
        conflicts: ["barcode", "id"],
        show: true
    },

    {
        id: "sellerId",
        name: "Vendedor",
        description:
            "Filtra las ordenes por el usuario de tu tienda que realizó la venta.",
        icon: "👩‍💼",
        conflicts: ["barcode", "id"],
        permissions: ["user:List"],
        show: true
    },

    {
        id: "origin",
        name: "Origen",
        description: "Filtra las ordenes por su origen de creación.",
        icon: "🌐",
        conflicts: ["barcode", "id"],
        show: IS_ENABLED_ECOMMERCE_OPTIONS
    },
    {
        id: "supplyStoreId",
        name: "Tienda",
        description:
            "Filtra las ordenes por la tienda donde se realizó la venta.",
        icon: "🏪",
        conflicts: ["barcode", "id"],
        permissions: ["store:List"],
        show: true
    }
];

export const timeFilters = [
    {
        id: "dateRange",
        name: "Rango de fechas",
        description: "Filtra entre dos fechas anteriores a la fecha actual",
        conflicts: ["timeAgo"],
        icon: "🕣"
    },
    {
        id: "timeAgo",
        name: "Tiempo atras",
        description:
            "Filtra por un rango de tiempo a partir de la fecha actual",
        conflicts: ["dateRange"],
        icon: "🗓"
    }
];

export const commonFilters = [
    {
        id: "keyword",
        name: "Palabra clave",
        description: "Filtra por una palabra claves",
        icon: "🗝",
        show: true
    },
    {
        id: "highlightType",
        name: "Destacado",
        description: "Filtra si esta destacado",
        icon: "🌟",
        show: IS_ENABLED_ECOMMERCE_OPTIONS
    },
    {
        id: "active",
        name: "Publicado",
        description: "Filtra si esta publicado o oculto",
        icon: "🟢",
        show: IS_ENABLED_ECOMMERCE_OPTIONS
    }
];

export const sublinesFilters = [
    {
        id: "keyword",
        name: "Palabra clave",
        description: "Filtra por una palabra claves",
        icon: "🗝",
        show: true
    },
    {
        id: "highlightType",
        name: "Destacado",
        description: "Filtra si esta destacado",
        icon: "🌟",
        show: IS_ENABLED_ECOMMERCE_OPTIONS
    },
    {
        id: "active",
        name: "Publicado",
        description: "Filtra si esta publicado o oculto",
        icon: "🟢",
        show: IS_ENABLED_ECOMMERCE_OPTIONS
    },
    {
        id: "line",
        name: "Línea",
        description: "Filtra entre las líneas registradas",
        scope: "",
        icon: "➖",
        show: true,
        permissions: ["line:List"]
    }
];

export const linesFilters = [
    {
        id: "keyword",
        name: "Palabra clave",
        description: "Filtra por una palabra claves",
        icon: "🗝",
        show: true
    },
    {
        id: "highlightType",
        name: "Destacado",
        description: "Filtra si esta destacado",
        icon: "🌟",
        show: IS_ENABLED_ECOMMERCE_OPTIONS
    },
    {
        id: "active",
        name: "Publicado",
        description: "Filtra si esta publicado o oculto",
        icon: "🟢",
        show: IS_ENABLED_ECOMMERCE_OPTIONS
    },
    {
        id: "type",
        name: "Tipo",
        description: "Filtra si es categoría o subcategoría",
        icon: "〰",
        show: true
    },
    {
        id: "line",
        name: "Categoría padre",
        description: "Filtra entre las categorías registradas",
        scope: "",
        icon: "➖",
        show: true,
        permissions: ["line:List"]
    }
];

export const bannersFilters = [
    {
        id: "keyword",
        name: "Palabra clave",
        description: "Filtra por una palabra claves",
        icon: "🗝"
    },
    {
        id: "line",
        name: "Subcategoría",
        description: "Filtra entre las subcategorías registradas",
        scope: "",
        icon: "➖"
    }
];

export const usersFilters = [
    {
        id: "phone",
        name: "Celular",
        description: "Filtra por celular",
        conflicts: ["identificationNumber", "email"],
        icon: "📱"
    },
    {
        id: "email",
        name: "Correo",
        description: "Filtra por correo electrónico",
        conflicts: ["identificationNumber", "phone"],
        icon: "✉"
    },
    {
        id: "identificationNumber",
        name: "Número de indentificación",
        description: "Filtra por número de indentificación",
        conflicts: ["phone", "email"],
        icon: "🚻"
    }
];

export const customersFilters = [
    {
        id: "phone",
        name: "Celular",
        description: "Filtra por celular",
        conflicts: ["identificationNumber", "email", "fullName"],
        icon: "📱"
    },
    {
        id: "email",
        name: "Correo",
        description: "Filtra por correo electrónico",
        conflicts: ["identificationNumber", "phone", "fullName"],
        icon: "✉"
    },
    {
        id: "identificationNumber",
        name: "Número de indentificación",
        description: "Filtra por número de indentificación",
        conflicts: ["phone", "email", "fullName"],
        icon: "🚻"
    },
    {
        id: "fullName",
        name: "Nombre",
        description: "Filtra por nombre",
        conflicts: ["phone", "email", "identificationNumber"],
        icon: "🧑"
    }
];

export const tenantsFilters = [
    {
        id: "name",
        name: "Nombre o slug",
        description: "Filtra por una parte del nombre o del slug del tenant.",
        icon: "🔎",
        show: true
    },
    {
        id: "id",
        name: "Usuario",
        description:
            "Busca un usuario por correo o nombre y muestra el tenant al que pertenece.",
        icon: "👤",
        show: true
    },
    {
        id: "planCode",
        name: "Plan",
        description: "Filtra por el plan de la suscripción vigente.",
        icon: "💎",
        show: true
    },
    {
        id: "businessType",
        name: "Tipo de negocio",
        description:
            "Filtra por el tipo de negocio que eligió el tenant en el onboarding.",
        icon: "🏪",
        show: true
    },
    {
        id: "subscriptionType",
        name: "Tipo de suscripción",
        description:
            "Filtra si la suscripción vigente es de prueba, paga o Free.",
        icon: "🧾",
        show: true
    },
    {
        id: "subscriptionStatus",
        name: "Estado",
        description:
            "Filtra por el estado de la suscripción vigente, o los tenants sin suscripción.",
        icon: "🚦",
        show: true
    },
    {
        id: "lastInvoiceStatus",
        name: "Estado de factura",
        description:
            "Filtra por el estado de la última factura de la suscripción vigente.",
        icon: "💳",
        show: true
    },
    {
        id: "createdAt",
        name: "Fecha de creación",
        description:
            "Filtra los tenants por el rango de fechas en que se crearon.",
        icon: "📅",
        show: true
    },
    {
        id: "currentPeriodEnd",
        name: "Vence",
        description:
            "Filtra por la fecha en que termina el periodo actual (pruebas y renovaciones por vencer).",
        icon: "⏳",
        show: true
    }
];
